 import moment from 'moment-timezone'

 export default {
   methods: {
     timestampToDatetime (timestamp) {
       if (!timestamp) {
         return
       }
       return moment.unix(timestamp).format('YYYY-MM-DD HH:mm')
     },

     timestampToDate (timestamp) {
       if (!timestamp) {
         return
       }
       return moment.unix(timestamp).format('YYYY-MM-DD')
     },

     unixTimestampToFromNow (timestamp, inDays = false) {
       if (!timestamp) {
         return
       }
       if (inDays) {
         let today = new Date()
         today.setHours(0, 0, 0, 0)
         return moment(today).diff(moment.unix(timestamp), 'days')
       }
       return moment.unix(timestamp).fromNow()
     },

     daysToGo (date) {
       const expiryDate = moment.tz(date, 'Asia/Hong_Kong')
       const today = moment.tz(moment(), 'Asia/Hong_Kong')
       return expiryDate.diff(today, 'days')
     },

     timeStringToTimestamp (time) {
       return moment(time).unix()
     }
   }
 }



// WEBPACK FOOTER //
// ./src/mixins/date.js